import CheckBox from "components/chexkbox";
import BookInf from ".";
import BookCard from "../bookCard";
import RmInf from "./rmInf";
import { useTranslation } from "react-i18next";
import Guest from "./guest";

type IProps = {
  cnlResvInf: any;
};

export default function BookCancelView({ cnlResvInf }: IProps) {
  const { t } = useTranslation();
  const payInf = {
    resvAmt: cnlResvInf?.resvAmt,
    payAmt: cnlResvInf?.payAmt,
    cnlFeeAmt: cnlResvInf?.cnlFeeAmt,
    payStaCd: cnlResvInf?.payStaCd,
    payStaNm: cnlResvInf?.payStaNm,
  };
  return (
    <>
      <BookInf payInf={payInf} handleResvCancel={() => {}}>
        <BookCard resvInf={cnlResvInf} lodVisible={true} />
        <RmInf resvInf={cnlResvInf} />
        {/* <Guest /> */}
      </BookInf>
    </>
  );
}
